import {
  comicPageImageStatusClass,
  comicPageImageStatusLabel,
} from '../../lib/comicPageImageStatus'
import type { ComicPageImageStatus } from '../../lib/comicTypes'
import { ChromeMetaTag } from '../ChromeTags'

type Props = {
  angular: boolean
  status: ComicPageImageStatus | undefined
  className?: string
}

/** 整页成图状态角标：{@link ChromeMetaTag} + {@link comicPageImageStatusClass} */
export function ComicPageImageStatusTag({ angular, status, className = '' }: Props) {
  return (
    <ChromeMetaTag
      angular={angular}
      className={[comicPageImageStatusClass(status), className].filter(Boolean).join(' ')}
    >
      {comicPageImageStatusLabel(status)}
    </ChromeMetaTag>
  )
}
